var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "prospect-simulations-data" } },
    [
      _vm._t("simulation-header"),
      _vm._l(_vm.simulations, function (simulation, i) {
        return _c(
          "div",
          {
            key: simulation._id,
            staticClass: "simulation card-item shadowless my-3",
            class: { active: _vm.extendedSimulation === i },
            style: { "--i": i },
          },
          [
            _c(
              "div",
              { staticClass: "simulation-info" },
              [
                _c("div", { staticClass: "is-flex-direction-row" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.dateToFormatedString(
                          simulation.createdAt,
                          "DD/MM/YY HH:mm"
                        )
                      ) +
                      " "
                  ),
                  simulation.hasOffer === false
                    ? _c("span", { staticClass: "no-offer-tag creditu-tag" }, [
                        _vm._v(_vm._s(_vm.$t("no-offer"))),
                      ])
                    : _vm._e(),
                ]),
                _vm._l(_vm.getOverviewMap(simulation), function (value, key) {
                  return _c("div", { key: key }, [
                    _vm._v(" " + _vm._s(_vm.$t(key)) + " "),
                    _c("span", { class: key }, [_vm._v(" " + _vm._s(value))]),
                  ])
                }),
                _c("div", [
                  _c(
                    "a",
                    {
                      attrs: { id: `extend-button-${i}`, href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          _vm.extendedSimulation =
                            _vm.extendedSimulation === i ? undefined : i
                        },
                      },
                    },
                    [
                      _c("span", {
                        staticClass: "fa fa-lg transition-slow",
                        class:
                          _vm.extendedSimulation === i
                            ? "fa-minus-circle"
                            : "fa-plus-circle",
                      }),
                    ]
                  ),
                ]),
              ],
              2
            ),
            _c(
              "div",
              {
                staticClass: "simulation-content transition-fast",
                attrs: { id: `simulation-details-${i}` },
              },
              [
                _c("div", { staticClass: "simulation-details" }, [
                  _c("div", { staticClass: "flex-box-content" }, [
                    _c(
                      "div",
                      { staticClass: "sim-row" },
                      _vm._l(
                        _vm.getDetailsMap(simulation),
                        function (column, columnIndex) {
                          return _c(
                            "div",
                            { key: columnIndex, staticClass: "sim-column" },
                            [
                              _c(
                                "ul",
                                _vm._l(column, function (value, key) {
                                  return _c("li", { key: key }, [
                                    _c("h5", [_vm._v(_vm._s(_vm.$t(key)))]),
                                    _c("span", [
                                      _vm._v(" " + _vm._s(value) + " "),
                                    ]),
                                  ])
                                }),
                                0
                              ),
                            ]
                          )
                        }
                      ),
                      0
                    ),
                    !simulation.hasOffer
                      ? _c(
                          "div",
                          { staticClass: "sim-column mt-2" },
                          [
                            _c(
                              "b-collapse",
                              {
                                staticClass: "card-suggestion py-3",
                                attrs: {
                                  open: false,
                                  animation: "slide",
                                  "aria-id": "suggestion",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "trigger",
                                      fn: function (props) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "card-header",
                                              attrs: {
                                                role: "button",
                                                "aria-controls": "suggestion",
                                                "aria-expanded": props.open,
                                              },
                                            },
                                            [
                                              _c(
                                                "h6",
                                                {
                                                  staticClass:
                                                    "card-header-title is-size-6 has-text-weight-normal py-0",
                                                },
                                                [
                                                  _c("b-icon", {
                                                    staticClass:
                                                      "has-text-primary pr-2",
                                                    attrs: {
                                                      icon: "circle-question",
                                                    },
                                                  }),
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("suggestions")
                                                    ) + " "
                                                  ),
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "card-header-icon p-0",
                                                    },
                                                    [
                                                      _c("b-icon", {
                                                        attrs: {
                                                          icon: props.open
                                                            ? "chevron-down"
                                                            : "chevron-up",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c("div", { staticClass: "card-content" }, [
                                  _c("div", { staticClass: "content" }, [
                                    _c(
                                      "ul",
                                      _vm._l(
                                        simulation.eligibilityMessages,
                                        function (message, key) {
                                          return _c("li", { key: key }, [
                                            _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(message),
                                              },
                                            }),
                                          ])
                                        }
                                      ),
                                      0
                                    ),
                                  ]),
                                ]),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ]),
              ]
            ),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }